import { formatRecordedMoney } from 'utils/recordedMoney';

export const revenueColumns = (publisher) => publisher
    ? [['total', 'Total income'], ['purchases', 'From purchases'], ['subscriptions', 'From subscriptions'], ['received', 'Payments received'], ['balance', 'Remaining income']]
    : [['total', 'Total sales'], ['purchases', 'Purchase sales'], ['subscriptions', 'Subscription sales'], ['share', 'Akello share']];

export function getRevenueRows(data, publisher) {
    const totals = publisher ? data?.totalIncomeByCurrency : data?.totalSalesByCurrency;
    const metadata = data?.currencies || [];
    const codes = Array.from(new Set([...metadata.map(({ code }) => code), ...Object.keys(totals || {})]));
    return codes.map((code) => {
        const currency = metadata.find((item) => item.code === code) || { code, label: code };
        const values = publisher ? {
            total: data?.totalIncomeByCurrency?.[code] ?? '0',
            purchases: data?.purchaseIncomeByCurrency?.[code] ?? '0',
            subscriptions: data?.subscriptionIncomeByCurrency?.[code] ?? '0',
            received: data?.amountReceivedByCurrency?.[code] ?? '0',
            balance: data?.netIncomeByCurrency?.[code] ?? '0',
        } : {
            total: data?.totalSalesByCurrency?.[code]?.beforeShare ?? '0',
            purchases: data?.purchaseSalesByCurrency?.[code]?.beforeShare ?? '0',
            subscriptions: data?.subscriptionSalesByCurrency?.[code]?.beforeShare ?? '0',
            share: data?.totalSalesByCurrency?.[code]?.afterShare ?? '0',
        };
        return { currency, values, hasActivity: Object.values(values).some((amount) => Number(amount) !== 0) };
    });
}

export const money = (row, key) => formatRecordedMoney(row.values[key], row.currency.code, row.currency);

export function revenueCsv(rows, publisher, period) {
    const columns = revenueColumns(publisher);
    const lines = [
        ['From date', 'To date', 'Currency', 'Currency name', ...columns.map(([, label]) => label)],
        ...rows.map((row) => [period.from || '', period.to || '', row.currency.code, row.currency.label,
            ...columns.map(([key]) => money(row, key))]),
    ];
    return lines.map((line) => line.map((value) => {
        const cell = String(value ?? '');
        // Prevent spreadsheet software from evaluating names as formulas.
        return `"${(/^[=+\-@\t\r]/.test(cell) ? "'" : '') + cell.replace(/"/g, '""')}"`;
    }).join(',')).join('\r\n');
}
